import { render, staticRenderFns } from "./AppHeaderButton.vue?vue&type=template&id=caa596da"
import script from "./AppHeaderButton.vue?vue&type=script&lang=js"
export * from "./AppHeaderButton.vue?vue&type=script&lang=js"
import style0 from "./AppHeaderButton.vue?vue&type=style&index=0&id=caa596da&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports